var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.683 10.817L18.385 8.52 3.25 23.655v2.297h2.298l15.135-15.135zm2.298-2.297l2.297-2.298-2.297-2.298-2.298 2.298 2.298 2.298zM6.893 29.203H0v-6.895L21.832.476a1.625 1.625 0 012.298 0l4.597 4.597a1.625 1.625 0 010 2.298L6.895 29.202h-.002z",
    fill: "#000"
  })));
}
export default SvgEdit;